import { LitElement, html, css, utils,   disableBodyScroll, enableBodyScroll, } from '@hh/global.js'

class HHCartNotification extends LitElement {
  static properties = {}

  constructor() {
    super()
    this.productAdded = null
    this.modalOpen = false
    this.handleProductAdded = this.handleProductAdded.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()
    document.addEventListener('productAdded', this.handleProductAdded)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    document.removeEventListener('productAdded', this.handleProductAdded)
  }

  async handleProductAdded(event) {
    const productAdded = event.detail.response;
    
    try {
      const response = await fetch(`/cart.js`)
      const cartData = await response.json()
      const cartItems = cartData.items || []
      
      this.cartItem = cartItems.find(item => item.id === productAdded.id)
      
      this.requestUpdate()
      this.modalOpen = true

      setTimeout(() => {
        this.modalOpen = false
        this.requestUpdate()
      }, 5000)
    } catch (error) {
      console.error('Error fetching cart data:', error)
    }
  }

  getColorFromTitle(title) {
    const parts = title.split('|')
    if (parts.length > 1) {
      return parts[parts.length - 1].trim()
    }
    return '';
  }

  handleNotificationClick(e) {
    this.modalOpen = false
    this.requestUpdate()
    this.toggleCart(e)
  }

  toggleCart(e) {
    e?.preventDefault()
    utils.toggle(document.body, ['mini-cart-is-active'])
    !!document.body.classList.contains('mini-cart-is-active')
      ? disableBodyScroll(utils.one('hh-mini-cart'))
      : enableBodyScroll(utils.one('hh-mini-cart'))
  }

  render() {
    const { cartItem } = this;
    const productName = cartItem ? cartItem.title.split('|')[0].trim() : '';
    const featuredImage = cartItem ? cartItem.featured_image : { url: '', alt: '' };
    const quantity = cartItem ? cartItem.quantity : 0;
  
    return html`
      <div class="cart-notification ${this.modalOpen ? 'is-open' : ''}" @click="${this.handleNotificationClick}">
        <div class="flex ais mb1">
          <h2 class="cart-notification__heading caption">Item Added to Cart</h2>
        </div>
        
        <div id="cart-notification-product" class="cart-notification__product">
          <img class="cart-notification-product__image"
            src="${featuredImage.url}&width=80"
            alt="${featuredImage.alt}"
            width="48"
            height="61"
            loading="lazy">
          
          <div class="cart-notification-product__info">
            <h3 class="cart-notification-product__name h6">${productName}</h3>
            <p class="c-subdued cart-item-color">${this.getColorFromTitle(cartItem ? cartItem.title : '')}</p>
            <p class="c-subdued">${'Qty: ' + quantity}</p>
          </div>
        </div>
      </div>
    `;
  }

  static styles = css`
    .cart-notification {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 2.5rem 4rem;
      background-color: var(--hh-color-reverse);
      opacity: 0;
      visibility: hidden;
      height: 0;
      transition: opacity 0.3s ease, visibility 0.3s ease, height 0.5s ease-in-out;
      overflow: hidden; 
      cursor: pointer;
    }
    
    .cart-notification.is-open {
      opacity: 1;
      visibility: visible;
      height: auto; 
      animation-name: slideDown;
      animation-duration: 0.5s;
      transition: opacity 0.3s ease, visibility 0.3s ease, height 0.5s ease-in-out;
    }
    
    @keyframes slideDown {
      0% {
        transform: translateY(-100%);
      }
      100% {
        transform: translateY(0);
      }
    }  
    
    .cart-notification__heading {
      align-items: center;
      display: flex;
      flex-grow: 1;
      margin-bottom: 0;
      margin-top: 0;
    
      font-size: 18px;
      font-weight: 500;
    }
    
    .cart-notification__product-card {
      display: flex;
      align-items: flex-start;
      gap: 1rem;
    }
    
    .cart-notification-product__name {
      font-size: 12px;
      font-weight: 400;
    }
    
    .cart-notification-product__info *,
    .cart-notification-product__info .cart-item__color {
      margin: 0;
    }
    
    .cart-notification-product__info p {
      color: var(--hh-color-subdued);
    }
    
    .cart-notification__heading .icon-checkmark {
      color: var(--hh-color-foreground);
      margin-right: 1rem;
      width: 1.3rem;
    }
    
    .cart-notification__product {
      align-items: flex-start;
      display: flex;
      gap: 1.5rem;
    }
    
    .cart-notification__product dl {
      margin-bottom: 0;
      margin-top: 0;
    }
    
    .cart-notification__product__image {
      border: 0.1rem solid var(--hh-color-light);
      margin-right: 1.5rem;
    }
    
    .cart-notification__product__name {
      margin-bottom: 0;
      margin-top: 0;
    }
    
    .cart-notification__product__option {
      color: var(--hh-color-neutral);
      margin-top: 1rem;
    }
    
    .cart-notification__product__option + .cart-notification__product__option {
      margin-top: 0.5rem;
    }
    
    .cart-notification__product__option > * {
      display: inline-block;
      margin: 0;
    }

    @media screen and (max-width: 767px) {
      .cart-notification {
        padding: 1.5rem;
      }

      .cart-notification__heading {
        font-size: 16px;
      }

      .cart-notification__product {
        gap: 1rem;
      }
    }
  
  `
}

customElements.define('hh-cart-notification', HHCartNotification)
